export const ACCESS_TOKEN_STORAGE_KEY = "access_token";
export const REFRESH_TOKEN_STORAGE_KEY = "refresh_token";
export const CODE_VERIFIER_STORAGE_KEY = "code_verifier";

export const CUSTOM_URL_SCHEME_HANDLER_TIMEOUT = 10 * 1000; // 10s
export const REFRESH_RETRY_TIMEOUT = 5 * 60 * 1000; // 5m
